import { c as _c } from "react/compiler-runtime";
import { ComponentProps } from 'react';
import { createNavigation } from 'next-intl/navigation';
import { Locale } from '@/utility/locale';
import { getShopDomainForLocale } from './domainConfig';
import { routing } from './routing';

// Used only when building a URL for a locale this deployment does not serve.
// Keep `localePrefixes` in domainConfig platform-scoped for next-intl routing.
const allLocalePrefixes: Record<string, string> = {
  'fr-CA': '/fr',
  'nl-BE': '/nl',
  'it-CH': '/it',
  'fr-CH': '/fr'
};

// Lightweight wrappers around Next.js' navigation
// APIs that consider the routing configuration
const {
  Link: NextIntlLink,
  redirect,
  usePathname,
  useRouter,
  getPathname,
  permanentRedirect
} = createNavigation(routing);
export type GetPathNameArgs = Parameters<typeof getPathname>[0];
const getDomainConfig = (locale: Locale) => {
  //@ts-expect-error no idea why domains is any
  return routing.domains.find(domain => domain.locales.includes(locale));
};

// Whether this deployment serves the locale is read from `routing.domains`, not from
// `locales`: the latter is derived from `process.env.PLATFORM`, which is not inlined into the
// client bundle, so in the browser an NA build would treat every NA locale as foreign and
// collapse the URL to the bare domain. `routing.domains` is runtime-resolved
// (`window.__runtimeDomains` on the client) and therefore correct on both platforms.
const getUrlWithDomain = (args: GetPathNameArgs) => {
  const domainConfig = getDomainConfig(args.locale);
  const domain = domainConfig?.domain ?? getShopDomainForLocale(args.locale);
  const pathname = domainConfig ? getPathname(args) : allLocalePrefixes[args.locale] || '/';
  return `https://${domain}${pathname}`;
};
type LinkProps = ComponentProps<typeof NextIntlLink>;
const Link = t0 => {
  const $ = _c(8);
  let children;
  let prefetch;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      prefetch,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = prefetch;
    $[3] = rest;
  } else {
    children = $[1];
    prefetch = $[2];
    rest = $[3];
  }
  const t1 = prefetch ?? false;
  let t2;
  if ($[4] !== children || $[5] !== rest || $[6] !== t1) {
    t2 = <NextIntlLink {...rest} prefetch={t1}>{children}</NextIntlLink>;
    $[4] = children;
    $[5] = rest;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export { Link, redirect, usePathname, useRouter, getPathname, getUrlWithDomain, getDomainConfig, permanentRedirect };